import React, { useState, useEffect } from "react";
import { Modal } from "react-responsive-modal";
import { ReactComponent as ShareIcon } from "assets/img/icons/shareIcon.svg";
import { useSelector } from "react-redux";
import { TaskShareContext } from "store/contexts/taskShareContext";
import Scrollbar from "react-scrollbars-custom";
import Button from "components/CustomButton";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";
import Loader from "components/Loader";
import Accordion from "components/Accordion";
import AccordionItem from "components/AccordionItem";
import AccordionItemHeading from "components/AccordionItemHeading";
import AccordionItemPanel from "components/AccordionItemPanel";
import AllList from "./AllList";
import classNames from "classnames";
import { useToasts } from "react-toast-notifications";
import TeamService from "services/TeamService";
import { useTimelineContext } from "store/contexts/timelineContext";

var styles = {
  headingDailog: {
    fontWeight: "600",
  },
  listIteamHeading: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px",
    gap: "15px",
  },
  teamDetail: {
    display: "flex",
    gap: "5px",
    fontWeight: "400",
    alignItems: "center",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
  },
  avatar: {
    minHeight: "30px",
    height: "30px",
    minWidth: "30px",
    width: "30px",
    borderRadius: "50%",
  },
  teamNameAll: {
    fontWeight: "bolder",
  },
  uncheckbox: {
    width: "20px",
    height: "20px",
  },
  checkbox: {
    width: "23px",
    height: "23px",
  },
  rightButton: {
    position: "absolute",
    top: "0",
    right: "0",
  },
  noTeams: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  shareButton: {
    cursor: "pointer",
  },
  loaderClass: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  dialogTitle: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "0 0 auto",
    margin: 0,
    padding: "12px 0px 12px",
  },
  doneButton: {
    width: "100px",
    background: "none",
    height: "unset",
    color: "#ffa100",
    boxShadow: "unset",
  },
};

export default ({ myteam_id, listTask }) => {
  const classes = styles;
  const [dialogState, setDialogState] = useState(false);
  const [allTeams, setAllTeams] = useState();
  const { teams } = useSelector((state) => state.teamsReducer);
  const [selectedTeamId, setSelectedTeamId] = useState(null);
  const { addToast } = useToasts();
  const [isloading, setLoading] = useState(false);
  const { setHide } = useTimelineContext();

  useEffect(() => {
    if (teams === undefined) {
      return;
    }

    setAllTeams(
      teams.filter((all_teams) => {
        return all_teams?.id !== myteam_id;
      })
    );
  }, [teams, myteam_id]);

  const handleChange = (e) => {
    if (e[0]) {
      setSelectedTeamId(e[0]);
    }
  };

  const checkSrc = (e) => {
    e.target.src = DefaultTeamAvatar;
  };

  const ShareTodoListItem = async (list, shareComment) => {
    setLoading(true);
    await TeamService.shareTodoListItem(
      myteam_id,
      listTask?.todo_list_id,
      listTask?.id,
      {
        team_id: list.team_id,
        todo_list_id: list.id,
        include_expressions: shareComment,
      }
    );
    setLoading(false);
    handleShareModal(false);
    addToast("Your task item is shared. ", { appearance: "success" });
  };

  const handleShareModal = (val) => {
    setDialogState(val);
    setHide(val);
  };

  return (
    <>
      <span
        onClick={() => {
          handleShareModal(true);
        }}
        style={classes.shareButton}
        className="p-share-btn"
      >
        <ShareIcon
          className="mwh-15"
          style={{ fill: "#6c737e", width: "100%", height: "100%" }}
        />
        Share
      </span>
      <Modal
        open={dialogState}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        center={true}
        onClose={() => handleShareModal(false)}
        showCloseIcon={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "shareModalPadding",
        }}
      >
        <TaskShareContext.Provider value={{ ShareTodoListItem, isloading }}>
          <div className="modal fade popup-modal">
            <div className="modal-content">
              <div className="modal-body">
                <div style={classes.dialogTitle}>
                  <h5 style={classes.headingDailog}>Select Teams Todo List</h5>
                </div>
                <div className="taskShareContent">
                  <Scrollbar style={{ paddingRight: "10px" }}>
                    <div style={classes.listContainer}>
                      {!allTeams && (
                        <div style={classes.loaderClass}>
                          <Loader />
                        </div>
                      )}
                      <Accordion
                        className={classNames({
                          todoListAccordion: true,
                          disabled: isloading ? true : false,
                        })}
                        onChange={handleChange}
                      >
                        {allTeams?.length !== 0 &&
                          allTeams?.map((allteam) => (
                            <AccordionItem
                              key={allteam?.id}
                              teamId={allteam?.id}
                            >
                              <AccordionItemHeading
                                className={"todoListAccordionButton"}
                              >
                                <div>
                                  <div style={classes.teamDetail}>
                                    <img
                                      onError={checkSrc}
                                      alt={`${allteam.avatar}`}
                                      style={classes.avatar}
                                      src={allteam.avatar ?? DefaultTeamAvatar}
                                    />
                                    <span
                                      className="postShareTeam"
                                      style={classes.teamName}
                                    >
                                      {allteam.name}
                                    </span>
                                  </div>
                                </div>
                              </AccordionItemHeading>
                              <AccordionItemPanel>
                                {selectedTeamId && (
                                  <AllList
                                    selectedTeamId={selectedTeamId}
                                    teamIds={allteam.id}
                                  />
                                )}
                              </AccordionItemPanel>
                            </AccordionItem>
                          ))}
                      </Accordion>
                      {allTeams?.length === 0 && (
                        <div style={classes.noTeams}>
                          <p>You don't have any teams.</p>
                        </div>
                      )}
                    </div>
                  </Scrollbar>
                </div>
                <div>
                  <Button
                    type="button"
                    disabled={isloading ? true : false}
                    buttonClass="small-btn me-2"
                    name="Cancel"
                    onClick={() => handleShareModal(false)}
                  />
                </div>
              </div>
            </div>
          </div>
        </TaskShareContext.Provider>
      </Modal>
    </>
  );
};
